import i18n from 'es2015-i18n-tag';
import ROUTES from '../../router/routing';

const { translate: $t } = i18n;

export const Section = {
    BEGINNING_OF_WORK: 'BEGINNING_OF_WORK',
    INBOX: 'INBOX',
    PAYMENT: 'PAYMENT',
    PARTNERSHIP: 'PARTNERSHIP',
    WIDGET: 'WIDGET',
    CHATBOTS: 'CHATBOTS',
    CRM: 'CRM',
};

function articles() {
    return [
        {
            url: ROUTES.HELP_CENTER_BEGINNING_INSTAGRAM,
            title: $t('__help.beginning.instagram'),
            date: '05.07.2023',
            section: Section.BEGINNING_OF_WORK,
        },
        {
            url: ROUTES.HELP_CENTER_BEGINNING_WHATSAPP,
            title: $t('__help.beginning.whatsapp'),
            date: '05.07.2023',
            section: Section.BEGINNING_OF_WORK,
        },
        {
            url: ROUTES.HELP_CENTER_BEGINNING_WABA,
            title: $t('__help.beginning.waba'),
            date: '17.07.2023',
            section: Section.BEGINNING_OF_WORK,
        },
        {
            url: ROUTES.HELP_CENTER_BEGINNING_VKONTAKTE,
            title: $t('Connecting VK'),
            date: '23.11.2022',
            section: Section.BEGINNING_OF_WORK,
        },
        {
            url: ROUTES.HELP_CENTER_BEGINNING_VIBER_BOT,
            title: $t('Connecting Viber Bot'),
            date: '23.11.2022',
            section: Section.BEGINNING_OF_WORK,
        },
        {
            url: ROUTES.HELP_CENTER_BEGINNING_TELEGRAM,
            title: $t('__help.beginning.telegram'),
            date: '05.07.2023',
            section: Section.BEGINNING_OF_WORK,
        },
        {
            url: ROUTES.HELP_CENTER_BEGINNING_TELEGRAM_BOT,
            title: $t('Connecting Telegram Bot'),
            date: '02.12.2022',
            section: Section.BEGINNING_OF_WORK,
        },
        {
            url: ROUTES.HELP_CENTER_BEGINNING_AVITO,
            title: $t('Connecting Avito'),
            date: '02.12.2022',
            section: Section.BEGINNING_OF_WORK,
        },
        {
            url: ROUTES.HELP_CENTER_BEGINNING_AUTO_RU,
            title: $t('Connecting Auto.ru'),
            date: '30.07.2024',
            section: Section.BEGINNING_OF_WORK,
        },
        {
            url: ROUTES.HELP_CENTER_BEGINNING_FACEBOOK_MESSENGER,
            title: $t('Connecting Facebook messenger'),
            date: '02.12.2022',
            section: Section.BEGINNING_OF_WORK,
        },
        {
            url: ROUTES.HELP_CENTER_BEGINNING_FACEBOOK_COMMENTS,
            title: $t('Connecting Facebook Comments'),
            date: '02.12.2022',
            section: Section.BEGINNING_OF_WORK,
        },
        {
            url: ROUTES.HELP_CENTER_BEGINNING_FACEBOOK_LEADS,
            title: $t('Connecting Facebook Leads'),
            date: '06.12.2022',
            section: Section.BEGINNING_OF_WORK,
        },
        {
            url: ROUTES.HELP_CENTER_BEGINNING_EMAIL,
            title: $t('Connecting Email'),
            date: '06.12.2022',
            section: Section.BEGINNING_OF_WORK,
        },
        {
            url: ROUTES.HELP_CENTER_BEGINNING_DISCORD,
            title: $t('Connecting Discord'),
            date: '06.12.2022',
            section: Section.BEGINNING_OF_WORK,
        },
        {
            url: ROUTES.HELP_CENTER_BEGINNING_OK,
            title: $t('Connecting Ok'),
            date: '06.12.2022',
            section: Section.BEGINNING_OF_WORK,
        },
        {
            url: ROUTES.HELP_CENTER_BEGINNING_TELEPHONY,
            title: $t('__help.beginning.telephony'),
            date: '10.10.2023',
            section: Section.BEGINNING_OF_WORK,
        },
        {
            url: ROUTES.HELP_CENTER_BEGINNING_MANAGER,
            title: $t('Connecting Manager'),
            date: '06.12.2022',
            section: Section.BEGINNING_OF_WORK,
        },
        {
            url: ROUTES.HELP_CENTER_BEGINNING_TEMPLATES,
            title: $t('Setting up templates'),
            date: '06.12.2022',
            section: Section.BEGINNING_OF_WORK,
        },
        {
            url: ROUTES.HELP_CENTER_BEGINNING_NOTIFICATIONS,
            title: $t('Notification settings'),
            date: '06.12.2022',
            section: Section.BEGINNING_OF_WORK,
        },
        {
            url: ROUTES.HELP_CENTER_BEGINNING_BLOCK_LIST,
            title: $t('Stop list'),
            date: '06.12.2022',
            section: Section.BEGINNING_OF_WORK,
        },
        {
            url: ROUTES.HELP_CENTER_INBOX_NEW_CHATS,
            title: $t('New chats'),
            date: '22.09.2022',
            section: Section.INBOX,
        },
        {
            url: ROUTES.HELP_CENTER_INBOX_MY_CHATS,
            title: $t('My chats'),
            date: '22.09.2022',
            section: Section.INBOX,
        },
        {
            url: ROUTES.HELP_CENTER_INBOX_ARCHIVE,
            title: $t('Archive'),
            date: '22.09.2022',
            section: Section.INBOX,
        },
        {
            url: ROUTES.HELP_CENTER_INBOX_SALES_FUNNEL,
            title: $t('Funnel'),
            date: '22.09.2022',
            section: Section.INBOX,
        },
        {
            url: ROUTES.HELP_CENTER_INBOX_FILTERS,
            title: $t('Filters'),
            date: '22.09.2022',
            section: Section.INBOX,
        },
        {
            url: ROUTES.HELP_CENTER_INBOX_SEARCH,
            title: $t('System search'),
            date: '03.01.2023',
            section: Section.INBOX,
        },
        {
            url: ROUTES.HELP_CENTER_INBOX_TAGS,
            title: $t('Tags'),
            date: '03.01.2023',
            section: Section.INBOX,
        },
        {
            url: ROUTES.HELP_CENTER_INBOX_PRODUCTS,
            title: $t('Products goods'),
            date: '03.01.2023',
            section: Section.INBOX,
        },
        {
            url: ROUTES.HELP_CENTER_INBOX_REACH_OUT_FIRST,
            title: $t('Write first'),
            date: '03.01.2023',
            section: Section.INBOX,
        },
        {
            url: ROUTES.HELP_CENTER_INBOX_CROSSCHANNEL_REPLY,
            title: $t('Cross-channel response'),
            date: '03.01.2023',
            section: Section.INBOX,
        },
        {
            url: ROUTES.HELP_CENTER_INBOX_BULK_ACTIONS,
            title: $t('Bulk Actions'),
            date: '16.02.2023',
            section: Section.INBOX,
        },
        {
            url: ROUTES.HELP_CENTER_INBOX_PROFILE,
            title: $t('Profiles'),
            date: '16.02.2023',
            section: Section.INBOX,
        },
        {
            url: ROUTES.HELP_CENTER_INBOX_ANALYTICS_COMPANY,
            title: $t('Company Analytics'),
            date: '16.02.2023',
            section: Section.INBOX,
        },
        {
            url: ROUTES.HELP_CENTER_INBOX_ANALYTICS_MANAGERS,
            title: $t('Manager work analytics'),
            date: '16.02.2023',
            section: Section.INBOX,
        },
        {
            url: ROUTES.HELP_CENTER_INBOX_EMPLOYEE_PERFORMANCE,
            title: $t('Employee performance analytics'),
            date: '16.02.2023',
            section: Section.INBOX,
        },
        {
            url: ROUTES.HELP_CENTER_PAYMENT_PRICING,
            title: $t('Tariffs'),
            date: '23.01.2023',
            section: Section.PAYMENT,
        },
        {
            url: ROUTES.HELP_CENTER_PAYMENT_PAYMENTS,
            title: $t('Payment'),
            date: '23.01.2023',
            section: Section.PAYMENT,
        },
        {
            url: ROUTES.HELP_CENTER_PAYMENT_INVOICES,
            title: $t('Payment for legal entities'),
            date: '23.01.2023',
            section: Section.PAYMENT,
        },
        {
            url: ROUTES.HELP_CENTER_PARTNERSHIP_PROGRAM,
            title: $t('Affiliate program rules'),
            date: '14.12.2022',
            section: Section.PARTNERSHIP,
        },
        {
            url: ROUTES.HELP_CENTER_PARTNERSHIP_LINK,
            title: $t('Affiliate link'),
            date: '14.12.2022',
            section: Section.PARTNERSHIP,
        },
        {
            url: ROUTES.HELP_CENTER_PARTNERSHIP_ANALYTICS,
            title: $t('Partner acquisition analytics'),
            date: '14.12.2022',
            section: Section.PARTNERSHIP,
        },
        {
            url: ROUTES.HELP_CENTER_PARTNERSHIP_WITHDRAWAL,
            title: $t('Withdrawal from the affiliate program'),
            date: '14.12.2022',
            section: Section.PARTNERSHIP,
        },
        {
            url: ROUTES.HELP_CENTER_LIVE_CHAT,
            title: $t('Widget functionality'),
            date: '30.01.2023',
            section: Section.WIDGET,
        },
        {
            url: ROUTES.HELP_CENTER_LIVE_CHAT_VISITORS,
            title: $t('Visitor analytics'),
            date: '25.10.2023',
            section: Section.WIDGET,
        },
        {
            url: ROUTES.HELP_CENTER_LIVE_CHAT_INSIGHTS,
            title: $t('Typing insights'),
            date: '25.10.2023',
            section: Section.WIDGET,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_B24_AVITO,
            title: $t('Avito integration with Bitrix24'),
            date: '28.09.2023',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_B24_FACEBOOK_COMMENTS,
            title: $t('Facebook Comments integration with Bitrix24'),
            date: '28.09.2023',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_B24_FACEBOOK_MESSENGER,
            title: $t('Facebook Messenger integration with Bitrix24'),
            date: '28.09.2023',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_B24_INSTAGRAM,
            title: $t('Instagram integration with Bitrix24'),
            date: '28.09.2023',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_B24_ODNOKLASSNIKI,
            title: $t('Odnoklasniki integration with Bitrix24'),
            date: '28.09.2023',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_B24_TELEGRAM,
            title: $t('Telegram integration with Bitrix24'),
            date: '28.10.2022',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_B24_TELEGRAM_BOT,
            title: $t('Telegram Bot integration with Bitrix24'),
            date: '28.10.2022',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_B24_VIBER_BOT,
            title: $t('Viber Bot integration with Bitrix24'),
            date: '27.10.2022',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_B24_VKONTAKTE,
            title: $t('Vkontakte integration with Bitrix24'),
            date: '27.10.2022',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_B24_WHATSAPP,
            title: $t('WhatsApp integration with Bitrix24'),
            date: '27.10.2022',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_B24_WABA,
            title: $t('Waba integration with Bitrix24'),
            date: '18.10.2023',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_AMO_WHATSAPP,
            title: $t('WhatsApp integration with Amo'),
            date: '24.11.2022',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_AMO_WABA,
            title: $t('Waba integration with AmoCRM'),
            date: '18.10.2023',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_AMO_INSTAGRAM,
            title: $t('Instagram integration with Amo'),
            date: '24.11.2022',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_AMO_VKONTAKTE,
            title: $t('Vkontakte integration with Amo'),
            date: '24.11.2022',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_AMO_ODNOKLASSNIKI,
            title: $t('Odnoklasniki integration with Amocrm'),
            date: '10.02.2023',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_AMO_VIBER,
            title: $t('Viber Bot integration with Amo'),
            date: '24.11.2022',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_AMO_TELEGRAM,
            title: $t('Telegram integration with Amo'),
            date: '24.11.2022',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_AMO_TELEGRAM_BOT,
            title: $t('Telegram Bot integration with AmoCRM'),
            date: '24.01.2023',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_AMO_AVITO,
            title: $t('Avito integration with AmoCRM'),
            date: '24.01.2023',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_AMO_FB_COMMENTS,
            title: $t('Facebook Comments integration with AmoCRM'),
            date: '24.01.2023',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_AMO_FB_MESSENGER,
            title: $t('Facebook Messenger integration with AmoCRM'),
            date: '24.01.2023',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_AMO_DISCORD,
            title: $t('Discord integration with AmoCRM'),
            date: '24.01.2023',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_MDT,
            title: $t('Integration with MDT'),
            date: '15.02.2023',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CRM_MOYSKLAD,
            title: $t('Integration with MOYSKLAD'),
            date: '25.10.2023',
            section: Section.CRM,
        },
        {
            url: ROUTES.HELP_CENTER_CHATBOT_BUILDER,
            title: $t('Creating new chatbot'),
            date: '05.06.2024',
            section: Section.CHATBOTS,
        },
        {
            url: ROUTES.HELP_CENTER_CHATBOT_FOR_TELEGRAM,
            title: $t('Creating chatbot for Telegram'),
            date: '09.10.2024',
            section: Section.CHATBOTS,
        },
        {
            url: ROUTES.HELP_CENTER_CHATBOT_FOR_INSTAGRAM,
            title: $t('Creating chatbot for Instagram'),
            date: '22.10.2024',
            section: Section.CHATBOTS,
        },
        {
            url: ROUTES.HELP_CENTER_CHATBOT_FOR_WHATSAPP,
            title: $t('Chatbot for WhatsApp'),
            date: '08.10.2024',
            section: Section.CHATBOTS,
        },
        {
            url: ROUTES.HELP_CENTER_CHAT_FOR_WORDPRESS,
            title: $t('Chat for WordPress'),
            date: '02.07.2024',
            section: Section.WIDGET,
        },
    ];
}

export default articles;
